// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-nQYC","options":"styles_options__+7S2E","option":"styles_option__BxwPZ","option_icon":"styles_option_icon__JT8YN","heading":"styles_heading__FFyou"};